class AlpineStore {
  constructor() {
    // スマホ判別
    Alpine.store("device",{
      mobile: window.innerWidth <= 768
    } );
  
    function checkScreenSize() {
      Alpine.store("device",{
        mobile: window.innerWidth <= 768
      } );
    }
  
    window.addEventListener("resize", checkScreenSize);
  }
}
